import { useSelector } from 'react-redux';
import { RootState } from '@/types/graph';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { PracticeLanding } from '@/pages/onboarding/landing/PracticeLanding';
import { LandingMmg } from '@/pages/onboarding/landing/LandingMmg';
import { UnavailableQuestionnairePage } from '@/pages/onboarding/UnavailableQuestionnairePage';
import { isMmgVariant } from '@/util/mmg';
import { selectEffectiveProfessional } from '@/util/professional';
import { getVisibleWelcomeMessage } from '@aldebaran/common/util/welcomeMessage';

export const LandingPractice = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  const practice = useSelector(
    (state: RootState) => state.consultation.practice,
  );
  const consultationDate = useSelector((state: RootState) =>
    state.consultation.date ? new Date(state.consultation.date) : undefined,
  );
  // Active questionnaire variant (covers the public `?variant=` path, which sets
  // graph.variant but not consultation.variant).
  const isMmg = useSelector((state: RootState) =>
    isMmgVariant(state.graph.variant),
  );
  // An MMG invitation only ever comes from the kiosk continuation SMS (ALDO-2759)
  const isKioskContinuation = useSelector(
    (state: RootState) => state.graph.mode === 'INVITATION',
  );
  // MMG check-in subtitle: the (default) professional's welcome message.
  const welcomeMessage = useSelector((state: RootState) =>
    getVisibleWelcomeMessage(selectEffectiveProfessional(state)),
  );

  if (!practice) {
    return <UnavailableQuestionnairePage />;
  }

  // MMG variants get their own dedicated check-in landing rather than the
  // generic practice landing (ALDO-2540).
  if (isMmg) {
    return (
      <LandingMmg
        practice={practice}
        consultationDate={consultationDate}
        welcomeMessage={welcomeMessage}
        isKioskContinuation={isKioskContinuation}
        onRegister={navigateNext}
      />
    );
  }

  return (
    <PracticeLanding
      practice={practice}
      consultationDate={consultationDate}
      onPrepareConsultation={navigateNext}
    />
  );
};
